import React from "react";
import "../styles/Footer.css";
import { FaLinkedinIn } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a href="#about">About Us</a>
        <a href="#blog">Blog</a>
        <a href="#products">Products</a>
        <a href="#services">Services</a>
        <a href="#why-us">Why Us</a>
        <a href="#contact">Contact</a>
      </div>

    
      <p className="footer-copy">
        © {new Date().getFullYear()} Venturebiz Promotions Pvt Ltd
      </p>
      <p className="tagline">Empowering Enterprises Enriching Societies.</p>

      <div className="footer-social">
        <a
          href="https://www.linkedin.com/company/venturebiz/"
          target="_blank"
          rel="noreferrer"
          className="linkedin-link"
        >
          <FaLinkedinIn className="linkedin-icon" />
          <span>Follow us on LinkedIn</span>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
